import { useEffect, useState } from "react";
import ClientService from "../services/client/ClientService";
import logger from "../utils/logger";

export function usePushNotifications({ isAdmin, isStaff = false }) {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

    const [permission, setPermission] = useState(
        (isSafari || isIos) && !isStandalone ? 'unavailable' : Notification.permission
    );

    useEffect(() => {
        if (!isAdmin && !isStaff) return;

        if ((isSafari || isIos) && !isStandalone) {
            return;
        }

        async function setupPush() {
            if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
                return;
            }

            try {
                const swReg = await navigator.serviceWorker.register('/push.js');
                const perm = await Notification.requestPermission();
                setPermission(perm);

                if (perm === 'granted') {
                    const subscription = await swReg.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: urlBase64ToUint8Array('BAYOOdZx8_FLyZJvOyJMqJJMSnft58pwJ50jeFD0KPFtxNjyRiLmdQ__GiyPQpRtl1CjnEOBZJpTKNichshyC0w')
                    });

                    if (isStaff) {
                        await ClientService.subscribeStaffNotifications({ subscription });
                    } else {
                        await ClientService.subscribeNotifications({ subscription });
                    }
                }
            } catch (err) {
                logger.error("Error registrando push notifications:", err);
                setPermission('denied');
            }
        }

        const timer = setTimeout(() => {
            setupPush();
        }, isIos ? 2000 : 500);

        return () => clearTimeout(timer);
    }, [isAdmin, isStaff, isSafari, isIos, isStandalone]);

    return permission;
}

export async function setupPushNotifications({ isStaff = false } = {}) {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        return 'unsupported';
    }

    try {
        const swReg = await navigator.serviceWorker.register('/push.js');
        const perm = await Notification.requestPermission();

        if (perm === 'granted') {
            const subscription = await swReg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array('BAYOOdZx8_FLyZJvOyJMqJJMSnft58pwJ50jeFD0KPFtxNjyRiLmdQ__GiyPQpRtl1CjnEOBZJpTKNichshyC0w')
            });

            if (isStaff) {
                await ClientService.subscribeStaffNotifications({ subscription });
            } else {
                await ClientService.subscribeNotifications({ subscription });
            }
            return 'granted';
        } else {
            return perm;
        }
    } catch (err) {
        logger.error("Error registrando push notifications:", err);
        return 'error';
    }
}

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}